import React, { useState } from "react";
import { Input, Button, Col, Row, Form } from "antd";

import {
  RiBehanceFill,
  RiFacebookBoxFill,
  RiInstagramFill,
  RiLinkedinBoxFill,
  RiMailFill,
  RiMap2Fill,
  RiSkypeFill,
  RiTelegramFill,
  RiTwitterFill,
  RiWhatsappFill,
  RiYoutubeFill,
  RiSnapchatFill,
} from "react-icons/ri";
import { FaTiktok } from "react-icons/fa";
import { COLORS } from "../../../../config/theme";
import { FiExternalLink } from "react-icons/fi";

const { primaryDark } = COLORS;

const SocialLinks = ({ form }) => {
  const [isFacebook, setIsFacebook] = useState(false);
  const [isInstagram, setIsInstagram] = useState(false);
  const [isLinkedin, setIsLinkedin] = useState(false);
  const [isTwitter, setIsTwitter] = useState(false);
  const [isSkype, setIsSkype] = useState(false);
  const [isBehance, setIsBehance] = useState(false);
  const [isYoutube, setIsYoutube] = useState(false);
  const [isWhatsapp, setIsWhatsapp] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMail, setIsMail] = useState(false);
  const [isTelegram, setIsTelegram] = useState(false);
  const [isTiktok, setIsTiktok] = useState(false);
  const [isSnapchat, setIsSnapchat] = useState(false);

  const listOneIcons = [
    {
      isActive: isFacebook,
      setActive: setIsFacebook,
      icon: RiFacebookBoxFill,
      name: "facebook",
      prefix: "facebook.com/",
    },
    {
      isActive: isInstagram,
      setActive: setIsInstagram,
      icon: RiInstagramFill,
      name: "instagram",
      prefix: "instagram.com/",
    },
    {
      isActive: isLinkedin,
      setActive: setIsLinkedin,
      icon: RiLinkedinBoxFill,
      name: "linkedin",
      prefix: "linkedin.com/",
    },
    {
      isActive: isTwitter,
      setActive: setIsTwitter,
      icon: RiTwitterFill,
      name: "twitter",
      prefix: "twitter.com/",
    },
    {
      isActive: isSkype,
      setActive: setIsSkype,
      icon: RiSkypeFill,
      name: "skype",
      prefix: "skype.com/",
      placeholder: "Skype Id",
    },
    {
      isActive: isBehance,
      setActive: setIsBehance,
      icon: RiBehanceFill,
      name: "behance",
      prefix: "behance.com/",
    },
    {
      isActive: isYoutube,
      setActive: setIsYoutube,
      icon: RiYoutubeFill,
      name: "youtube",
      prefix: "youtube.com/",
    },
  ];

  const listTwoIcons = [
    {
      isActive: isWhatsapp,
      setActive: setIsWhatsapp,
      icon: RiWhatsappFill,
      name: "whatsapp",
      prefix: "wa.me/",
      placeholder: "phonenumber",
    },
    {
      setActive: setIsMaps,
      isActive: isMaps,
      icon: RiMap2Fill,
      name: "maps",
      prefix: "goo.gl/maps/",
      placeholder: "id",
    },
    {
      setActive: setIsMail,
      isActive: isMail,
      icon: RiMailFill,
      name: "mail",
      placeholder: "xyz@domain.com",
      prefix: "",
    },
    {
      setActive: setIsTelegram,
      isActive: isTelegram,
      icon: RiTelegramFill,
      name: "telegram",
      prefix: "t.me/",
    },
    {
      setActive: setIsTiktok,
      isActive: isTiktok,
      icon: FaTiktok,
      name: "tiktok",
      placeholder: "username",
      prefix: "vt.tiktok.com/",
    },
    {
      setActive: setIsSnapchat,
      isActive: isSnapchat,
      icon: RiSnapchatFill,
      name: "snapchat",
      placeholder: "username",
      prefix: "snapchat.com/add/",
    },
  ];

  return (
    <>
      <Row xs={12} md={24} align="center" style={{ gap: 15 }}>
        {listOneIcons.map(({ ...props }, index) => {
          return (
            <RoundIcon
              {...props}
              index={index}
              key={"icon" + index}
            ></RoundIcon>
          );
        })}
      </Row>

      <Row xs={12} md={24} align="center" style={{ gap: 15, marginTop: 15 }}>
        {listTwoIcons.map(({ ...props }, index) => {
          const key = index + listOneIcons.length;
          return (
            <RoundIcon {...props} index={key} key={"icon" + key}></RoundIcon>
          );
        })}
      </Row>
      <Col xs={24} md={24} style={{ marginTop: 15 }}>
        <Form.List name="socialLinks">
          {(fields) => (
            <>
              {fields.map(({ key, name, ...rest }) => {
                const isActive = form.getFieldValue([
                  "socialLinks",
                  name,
                  "active",
                ]);
                const nameId = form.getFieldValue([
                  "socialLinks",
                  name,
                  "name",
                ]);
                const data = [...listOneIcons, ...listTwoIcons].find(
                  (icon) => icon.name === nameId
                );
                const Icon = data.icon;
                const placeholder = data.placeholder || "yourpage";
                const prefix = data.prefix;
                const link = form.getFieldValue(["socialLinks", name, "link"]);

                return (
                  <React.Fragment key={nameId}>
                    {isActive && (
                      <>
                        <Form.Item
                          {...rest}
                          name={[name, "linkValue"]}
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            style={{ borderRadius: 8 }}
                            placeholder={placeholder}
                            suffix={
                              <Button
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  borderRadius: 8,
                                }}
                                icon={
                                  <FiExternalLink style={{ marginRight: 5 }} />
                                }
                                onClick={() => {
                                  if (nameId === "mail") {
                                    window.open(`mailto:${link}`, "_blank");
                                  } else {
                                    window.open("https://" + link, "_blank");
                                  }
                                }}
                              >
                                Test
                              </Button>
                            }
                            prefix={
                              <>
                                <Icon
                                  color="lightgray"
                                  style={{
                                    fontSize: 30,
                                    marginRight: 10,
                                  }}
                                />
                                {prefix}
                              </>
                            }
                          />
                        </Form.Item>
                        <Form.Item name={[name, "link"]}>
                          <Input type="hidden"></Input>
                        </Form.Item>
                      </>
                    )}
                  </React.Fragment>
                );
              })}
            </>
          )}
        </Form.List>
      </Col>
    </>
  );
};

const SocialButton = ({ value, setActive, onChange, children, icon }) => {
  const SocialIcon = icon;

  return (
    <div
      onClick={() => {
        onChange(!value);
        setActive(!value);
      }}
      style={{
        cursor: "pointer",
        width: 60,
        height: 60,
        borderRadius: 30,
        border: `1px solid ${value ? primaryDark : "lightgray"}`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <SocialIcon
        color={value ? primaryDark : "lightgray"}
        style={{ fontSize: 30 }}
      >
        {children}
      </SocialIcon>
    </div>
  );
};

const RoundIcon = ({ name, index, isActive, setActive, icon, prefix }) => {
  return (
    <React.Fragment>
      <Form.Item name={["socialLinks", index, "name"]}>
        <Input type="hidden"></Input>
      </Form.Item>
      <Form.Item name={["socialLinks", index, "prefix"]} initialValue={prefix}>
        <Input type="hidden"></Input>
      </Form.Item>
      <Form.Item name={["socialLinks", index, "active"]}>
        <SocialButton setActive={setActive} icon={icon}></SocialButton>
      </Form.Item>
    </React.Fragment>
  );
};

export default SocialLinks;
